"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPublicKey = void 0;
const web3_js_1 = require("@solana/web3.js");
/**
 * Returns true if the given value is a {@link PublicKey}.
 * @param pk
 * @returns
 */
const isPublicKey = (pk) => {
    if (pk instanceof web3_js_1.PublicKey) {
        return true;
    }
    if (typeof pk !== "object" || Array.isArray(pk)) {
        return false;
    }
    try {
        new web3_js_1.PublicKey(pk);
        return true;
    }
    catch (e) {
        return false;
    }
};
exports.isPublicKey = isPublicKey;
//# sourceMappingURL=isPublicKey.js.map